import { render, staticRenderFns } from "./CaringCmInstitution.vue?vue&type=template&id=66212c1b"
import script from "./CaringCmInstitution.vue?vue&type=script&lang=js"
export * from "./CaringCmInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports